import { render, staticRenderFns } from "./DlgFileDelete.vue?vue&type=template&id=9afd7246&scoped=true&"
import script from "./DlgFileDelete.vue?vue&type=script&lang=ts&"
export * from "./DlgFileDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afd7246",
  null
  
)

export default component.exports